export default __webpack_public_path__ + "static/WETH-8f785563e47cbf3731606f12ef9ca756.png";